module.exports = __webpack_public_path__ + "img/multiplier_4_win.c0c10a00.png";